import i18n from 'i18next';
import { hasRestrictedRole } from 'globalutils/fmUtils';
import { UI_DATE_LOWER_FORMAT } from 'globalconfig/constants/static';

export const columns = [
  {
    id: 'driver_name',
    numeric: false,
    disablePadding: true,
    label: i18n.t('common.driver'),
    needSorting: true,
  },
  {
    id: 'vehicle_name',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.vehicle'),
    needSorting: true,
  },
  {
    id: 'date',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.date'),
    needSorting: true,
  },
  {
    id: 'hours',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.hoursWorked'),
    needSorting: true,
  },
  {
    id: 'distance',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.distance'),
    needSorting: true,
  },

  {
    id: 'actions',
    label: 'common.tools',
  },
];

export const udListColumns = [
  {
    id: 'time_from',
    numeric: false,
    disablePadding: true,
    label: i18n.t('common.startTime'),
    needSorting: false,
  },
  {
    id: 'time_to',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.endTime'),
    needSorting: false,
  },
  {
    id: 'distance',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.distance'),
    needSorting: false,
  },
  {
    id: 'location',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.location'),
    needSorting: false,
  },
  {
    id: 'driverId',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.assignedDriver'),
    needSorting: false,
  },
  {
    id: 'coDriverId',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.coDriver'),
    needSorting: false,
  },
  {
    id: 'note',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.notes'),
    needSorting: false,
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.status'),
    needSorting: false,
  },
];

export const logTableColumns = [
  {
    id: 'driver_name',
    numeric: false,
    disablePadding: true,
    label: i18n.t('common.driver'),
    needSorting: true,
  },
  {
    id: 'vehicle_name',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.vehicle'),
    needSorting: true,
  },
  {
    id: 'date',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.date'),
    needSorting: true,
  },
  {
    id: 'hours',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.hoursWorked'),
    needSorting: true,
  },
  {
    id: 'distance',
    numeric: false,
    disablePadding: false,
    label: i18n.t('common.distance'),
    needSorting: true,
  },

  {
    id: hasRestrictedRole(['ADMIN']) ? '' : 'actions',
    label: hasRestrictedRole(['ADMIN']) ? '' : 'Actions',
  },
];

export const englishToSpanish = {
  seconds: 'segundos',
  minutes: 'minutos',
  hours: 'horas',
  days: 'días',
  weeks: 'semanas',
  months: 'meses',
  years: 'años',
};

export const fields = [
  {
    type: 'text',
    value: i18n.t('Unidentified Driver'),
    field: 'driver_name',
    placeholder: i18n.t('common.driver'),
    label: i18n.t('common.driver'),
    disabled: true,
    defaultValue: i18n.t('Unidentified Driver'),
  },
  {
    type: 'date',
    value: '',
    field: 'dateFrom',
    placeholder: UI_DATE_LOWER_FORMAT,
    label: i18n.t('common.dateFrom'),
    isTimeNeeded: false,
  },
  {
    type: 'date',
    value: '',
    field: 'dateTo',
    placeholder: UI_DATE_LOWER_FORMAT,
    label: i18n.t('common.dateTo'),
    isTimeNeeded: false,
  },

  { type: 'submit', value: i18n.t('common.view') },
  { type: 'reset', value: i18n.t('common.clear') },
];
